(function () {
  const productKey = window.PURITY_PRODUCT_ID || "unknown";
  const STORAGE_KEY = "purity_reviews_" + productKey;

  function readReviews() {
    try {
      return JSON.parse(localStorage.getItem(STORAGE_KEY)) || [];
    } catch (e) {
      return [];
    }
  }

  function writeReviews(list) {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(list));
  }

  function starsHtml(rating, interactive) {
    let out = '<span class="reviews__stars" aria-label="' + rating + ' sur 5">';
    for (let i = 1; i <= 5; i++) {
      out += '<span class="reviews__star' + (i <= rating ? " is-filled" : "") + '" data-star="' + i + '">★</span>';
    }
    out += "</span>";
    return out;
  }

  function formatDate(iso) {
    const d = new Date(iso);
    return d.toLocaleDateString("fr-CA", { year: "numeric", month: "long", day: "numeric" });
  }

  function render() {
    const reviews = readReviews();
    const root = document.getElementById("reviews-root");
    if (!root) return;

    const avg = reviews.length
      ? (reviews.reduce((s, r) => s + r.rating, 0) / reviews.length).toFixed(1)
      : null;

    root.innerHTML = `
      <div class="reviews__head">
        <div>
          <span class="eyebrow">Avis clients</span>
          <h2 class="section__title">Ce qu'on en dit</h2>
        </div>
        ${
          avg
            ? `<div class="reviews__summary">
                <span class="reviews__avg">${avg}</span>
                ${starsHtml(Math.round(avg))}
                <span class="reviews__count">${reviews.length} avis</span>
              </div>`
            : ""
        }
      </div>

      <div class="reviews__list" id="reviews-list"></div>

      <div class="reviews__form-wrap">
        <h3>Laisser un avis</h3>
        <form class="reviews__form" id="reviews-form">
          <div class="reviews__form-row">
            <label>
              <span>Ton nom</span>
              <input type="text" name="name" required maxlength="60" placeholder="Prénom">
            </label>
            <label>
              <span>Note</span>
              <div class="reviews__picker" id="reviews-picker">${starsHtml(0)}</div>
              <input type="hidden" name="rating" required>
            </label>
          </div>
          <label>
            <span>Ton commentaire</span>
            <textarea name="text" required maxlength="600" rows="3" placeholder="Qu'est-ce que tu as pensé de cette pièce ?"></textarea>
          </label>
          <button type="submit">Publier l'avis</button>
        </form>
      </div>
    `;

    const listEl = document.getElementById("reviews-list");
    if (!reviews.length) {
      listEl.innerHTML = `<p class="reviews__empty">Aucun avis pour l'instant — sois le premier à partager ton expérience.</p>`;
    } else {
      listEl.innerHTML = reviews
        .slice()
        .reverse()
        .map(
          (r) => `
        <div class="reviews__item">
          <div class="reviews__item-head">
            <span class="reviews__item-name">${escapeHtml(r.name)}</span>
            ${starsHtml(r.rating)}
          </div>
          <span class="reviews__item-date">${formatDate(r.date)}</span>
          <p class="reviews__item-text">${escapeHtml(r.text)}</p>
        </div>`
        )
        .join("");
    }

    // Star picker interaction
    const picker = document.getElementById("reviews-picker");
    const ratingInput = document.querySelector('#reviews-form input[name="rating"]');
    let selectedRating = 0;
    picker.querySelectorAll(".reviews__star").forEach((star) => {
      star.addEventListener("click", () => {
        selectedRating = parseInt(star.dataset.star, 10);
        ratingInput.value = selectedRating;
        picker.querySelectorAll(".reviews__star").forEach((s) => {
          s.classList.toggle("is-filled", parseInt(s.dataset.star, 10) <= selectedRating);
        });
      });
    });

    document.getElementById("reviews-form").addEventListener("submit", (e) => {
      e.preventDefault();
      const form = e.target;
      if (!selectedRating) {
        picker.classList.add("is-required");
        return;
      }
      const name = form.name.value.trim();
      const text = form.text.value.trim();
      if (!name || !text) return;

      const list = readReviews();
      list.push({ name, rating: selectedRating, text, date: new Date().toISOString() });
      writeReviews(list);
      render();
    });
  }

  function escapeHtml(str) {
    const div = document.createElement("div");
    div.textContent = str;
    return div.innerHTML;
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", render);
  } else {
    render();
  }
})();
